import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gerar-boleto',
  templateUrl: './gerar-boleto.component.html',
  styleUrls: ['./gerar-boleto.component.scss']
})
export class GerarBoletoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
